import { gql } from "@apollo/client";

export const GET_WELLNESS_PLAN_CATALOG = gql`
  query getWellnessPlanCatalog($petId: String!) {
    getWellnessPlanCatalog(petId: $petId) {
      plans {
        planType
        displayName
        ageGroup
        recommended
        description
        annual {
          planId
          price
          enrollmentFee {
            price
          }
        }
        monthly {
          planId
          price
          enrollmentFee {
            price
          }
        }
        benefitsShort
        benefits {
          category
          items {
            name
            quantity
            discount
            unlimited
          }
        }
      }
    }
  }
`;
